// Referrer Portal (light login for external referrers).
import axios from 'axios';
import { API } from './_client';

const REFERRER_TOKEN_KEY = 'immipro_referrer_session';
const authed = axios.create({ baseURL: API.defaults.baseURL, headers: { 'Content-Type': 'application/json' } });
authed.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(REFERRER_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const referrer = {
  requestLogin: (email) => axios.post(`${API.defaults.baseURL}/referrer/request-login`, { email }).then((r) => r.data),
  consume: (token) => axios.post(`${API.defaults.baseURL}/referrer/consume`, { token }).then((r) => r.data),
  dashboard: () => authed.get('/referrer/dashboard').then((r) => r.data),
  setToken: (t) => localStorage.setItem(REFERRER_TOKEN_KEY, t),
  getToken: () => localStorage.getItem(REFERRER_TOKEN_KEY),
  clearToken: () => localStorage.removeItem(REFERRER_TOKEN_KEY),
};
